import React, {Fragment, useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import WebIcon from '@material-ui/icons/Web';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import WorkIcon from '@material-ui/icons/Public';
import ShareIcon from '@material-ui/icons/Share';
import PersonIcon from '@material-ui/icons/Lock';
import MouseIcon from '@material-ui/icons/Mouse';
import HelpIcon from '@material-ui/icons/Help';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InputAdornment from '@material-ui/core/InputAdornment';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import {GridList, List, Popup, Select, Search, Popover, PlusButton} from '../../../components';
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=>({
  top_bar:{
    width:'100vw',
    marginLeft:'-10px',
    ['@media (min-width:600px)']:{
      width:'calc(100vw - 60px)',
      marginLeft:'-20px'
    },
  }
}));


function Delete_popup(props){


  function onDelete(id){
    props.deleteDefault(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={'Delete default'} accept_button='Delete' handleClose={props.handleClose} accept_button_click={()=>{onDelete(props.default.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{"Are you sure you want to permanently delete these settings? This action can not be undone."}</Typography></div>
      </div>
    }/>
  )
}




function Shared(props){
  if(props.share==true){
    return(<Tooltip title={'Workspace document'} aria-label="add"><WorkIcon {...props}/></Tooltip>)
  }else{
    return(<Tooltip title={'Personal document'} aria-label="add"><PersonIcon {...props}/></Tooltip>)
  }
}

function Defaults(props){
  const[search, setSearch]=useState('');
  const[filter, setFilter]=useState('all');
  const[delete_popup, setDeletePopup]=useState(undefined);
  let classes=useStyles();

  useEffect(()=>{
    if(props.defaults==undefined){props.indexDefaults();}
  },[])

  //<Shared share={x.workspace_share} color='primary' style={{position:'absolute', right:'60px', top:'-1px'}}/><EditIcon style={{position:'absolute', right:'30px', top:'-1px'}} onClick={()=>{props.history.push('/email/documents/'+x.id+'/edit')}}/><DeleteIcon color='error' style={{position:'absolute', right:'5px', top:'-1px'}} onClick={()=>{setDeletePopup(x);}}/>
  let defaults=[]; for(let key in props.defaults){let name=props.defaults[key].name.toLowerCase(); let description=props.defaults[key].description.toLowerCase(); if(search=='' || name.includes(search.toLowerCase()) || description.includes(search.toLowerCase())){defaults.push(props.defaults[key])}}


  return(
    <div>
    {((props.workspace!=undefined && props.workspace.active_subscription!=undefined) || (props.workspace!=undefined && props.workspace.free_account==true))?<PlusButton color='primary' options={[{label:'Quizz', icon:<WebIcon/>, action:()=>{props.history.push('/defaults/new')}}]}/>:null}
    <div className={classes.top_bar} style={{marginTop:'-20px', boxShadow:'1px 1px 4px #888888', position:'relative', paddingTop:'12px', paddingBottom:'2px', zIndex:'3'}}>
    <Grid container>
      <Grid item xs={12} sm={6} md={4}><div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}><TextField type='name' InputProps={{startAdornment:<SearchIcon/>}} variant='outlined' size='small' label='Search' value={search} onChange={(e)=>{setSearch(e.target.value)}} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'5px', marginBottom:'5px', backgroundColor:'#f7f9fc'}}/></div></Grid>
    </Grid>
    </div>
    <div style={{width:'100%', height:'calc(100vh - 125px)'}}>
    <GridList list_items={defaults} rowHeight={130} responsive_columns={{0:1, 720:2, 1300:3, 1700:4}} component={(x)=>{
      if(x.deleted_at==null && ((filter=='personal_only' && x.user_id==props.me.id) || (filter=='workspace_only' && x.workspace_share==true) || filter=='all')){
        let options_list=[];
        options_list.push({id:5, icon:<EditIcon color='primary'/>, main_text:'Edit'});
        options_list.push({id:4, icon:<DeleteIcon color='error'/>, main_text:'Delete'});
        if(x.shareable_link==true){options_list.push({id:6, icon:<ShareIcon color='secondary'/>, main_text:'Share'});}
        console.log(x, options_list)
      return(
        <div style={{height:'100%', width:'100%', position:'relative', marginTop:'20px'}}>{
          <Paper style={{borderWidth:(x.prospect_safari_services.length>0)?'2px':'0px', borderStyle:'solid', borderColor:'red', overflowX:'hidden', overflowY:'hidden', height:'110px', width:'calc(100% - 40px)', marginLeft:'20px', position:'relative'}}>
            <div style={{boxShadow:'1px 1px 4px #888888', position:'relative', zIndex:'2', marginTop:'-10px', paddingTop:'8px', width:'100%'}}><Typography color='primary' style={{marginLeft:'30px', marginTop:'5px', marginBottom:'5px'}}>{(1==1)?<Tooltip title={(x.prospect_safari_services.length>0)?'Connected to subscription plan: '+x.prospect_safari_services[0].name:'Available to workspace'}><HelpIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>:<Tooltip title='Personal quizz'><PersonIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>}<span style={{width:'calc(100% - 30px)'}}>{x.name+' ('+x.last_push+')'}</span><Popover style={{position:'absolute', right:'0px'}} trigger={<MoreVertIcon color='primary' style={{position:'absolute', right:'0px', top:'0px', cursor:'pointer'}}/>} content={
              <div style={{width:'140px'}}>
              <List onClick={(item)=>{if(item.id==6){
                navigator.clipboard.writeText('https://'+window.location.host+'/companies/table?wdef='+x.path);
                window.setTimeout(function(){alert('Link copied to clipboard');},100);
              }else if(item.id==5){props.history.push('/defaults/'+x.id+'/edit');}else if(item.id==4){setDeletePopup(x);}}} list_data={options_list}/>
              </div>
            }/></Typography></div>
            <div style={{height:'calc(100% - 50px)', position:'relative', overflowY:'scroll', zIndex:'1', marginTop:'-3px'}}><div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'-2px', marginBottom:'0px'}}><Typography variant='caption'>{x.description}</Typography></div></div>
            <Grid container style={{height:'20px', paddingTop:'2px'}}>
            </Grid>
          </Paper>
        }</div>
      )
    }else{return null;}}}
    />
    </div>
      {(delete_popup!=undefined)?<Delete_popup {...props} default={delete_popup} handleClose={()=>{setDeletePopup(undefined)}}/>:null}
    </div>
  );
}

export default connect(ss,dd)(Defaults);


function ss(state){
  return{
    me:state.account.me,
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id],
    defaults:state.sales_coach.defaults,
  }
}

function dd(dispatch){
  return{
    deleteDefault:(id)=>{dispatch({type:'REQUEST_DELETE_DEFAULT', id:id});},
    indexDefaults:()=>{dispatch({type:'REQUEST_INDEX_DEFAULTS'});}
  }
}
